import React from 'react'
import { Container } from 'semantic-ui-react';

const AboutSection = () => (
  <div style={styles.root}>
    <Container>
      <h1 style={styles.titleText}>About Us</h1>
      <p>My mission is to provide a variety of Sari, Dress and Handmade Jewelleries to customers anywhere in India, within an affordable price range.</p>
      <p>All types of saree like khadi handloom saree handwoven jamdani kathastich saree bishnupuri silk khadi kurti & handmade jewellery are available.</p>
    </Container>
  </div>
)

const styles = {
  root: {
    paddingTop: '200px',
    paddingBottom: '200px',
  },
  titleText: {
    fontSize: '70px',
    fontStyle: 'italic',
  }
}

export {AboutSection};